module.exports = __webpack_public_path__ + "static/media/ChristmasCardEnvelope.7d53a391.jpg";